<template>
    <teleport to="body" v-if="tooltipVisible">
        <div
            class="absolute top-0 bottom-0 left-0 right-0 z-40"
            @click.self="closeTooltip"
        ></div>
    </teleport>

    <span class="relative">
        <span
            v-on:click="handleMouseClick"
            v-on:mouseenter="handleMouseEnter"
            v-on:mouseleave="handleMouseLeave"
            class="hover:cursor-pointer"
            ref="triggerContainer"
        >
            <slot name="trigger" />
        </span>
        <div
            v-if="tooltipVisible"
            :class="tooltipCss"
            :style="tooltipStyle"
            ref="contentContainer"
        >
            <slot name="content"></slot>
        </div>
    </span>
</template>

<script>
export default {
    name: "Tooltip",
    props: {
        cssClasses: {
            type: String,
            default: null,
        },
        widthPx: {
            type: [Number, String],
            default: 100,
        },
        openFrom: {
            type: String,
            default: "center",
        },
        hover: {
            type: Boolean,
            default: false,
        },
    },
    data() {
        return {
            tooltipVisible: false,
        };
    },
    methods: {
        openTooltip() {
            this.tooltipVisible = true;
        },
        closeTooltip() {
            this.tooltipVisible = false;
        },
        handleMouseClick() {
            this.openTooltip();
        },
        handleMouseEnter() {
            if (this.hover) {
                this.openTooltip();
            }
        },
        handleMouseLeave() {
            if (this.hover) {
                this.closeTooltip();
            }
        },
    },
    computed: {
        openWith() {
            return {
                click: "openTooltip",
            };
        },
        tooltipCss() {
            return (
                "absolute z-50" +
                " " +
                (this.cssClasses ??
                    "bg-black text-white drop-shadow-md rounded p-4 text-[15px]")
            );
        },
        tooltipStyle() {
            let containerWidth = this.$refs.triggerContainer.offsetWidth;
            let containerHeight = this.$refs.triggerContainer.offsetHeight;
            let widthStyle = "width:" + this.widthPx + "px; ";
            let positionStyle = "left: 0px";
            let leftAdjustment = Math.abs(
                (containerWidth - this.widthPx) * 0.5
            );
            // containerWidth > this.widthPx
            //     ? (containerWidth - this.widthPx) * 0.5
            //     : this.widthPx * 0.5;

            if (this.openFrom === "center") {
                positionStyle = "left:-" + leftAdjustment + "px";
            }

            if (this.openFrom === "right") {
                positionStyle = "right: 0px";
            }

            if (this.openFrom === "bottom-center") {
                positionStyle = "bottom: 0; left:-" + leftAdjustment + "px";
            }

            if (this.openFrom === "bottom-left") {
                positionStyle = "bottom: 0; right: 0px";
            }

            if (this.openFrom === "bottom-right") {
                positionStyle = "bottom: 0; right: 0px";
            }

            console.log(positionStyle);

            return widthStyle + " " + positionStyle;
        },
    },
};
</script>

<style scoped></style>
